<template>
  <ul>
    <router-link
      :to="{ name: 'Contact', params: { contactId: contact.topic.topicId } }"
      active-class="active"
      tag="li"
      class="media list"
      v-for="contact in contacts"
      :key="contact.topic.topicId"
    >
      <div class="media-body">
        <div class="contact-time float-right mt-1">
          {{ contact.topic.createdAt | moment }}
        </div>
        <div class="contact-header">
          {{ contact.topic.topicId | contact_id }}
          {{ contact.contactCategory.title }}
        </div>
        <div class="contact-author">
          {{
            contact.topic.createdByUser === null
              ? contact.topic.createdByAdmin.firstName +
                " " +
                contact.topic.createdByAdmin.lastName
              : contact.topic.createdByUser.firstName +
                " " +
                contact.topic.createdByUser.lastName
          }}

          [{{contact.home.address_no}}]
        </div>
        <div class="float-right ml-2" v-if="contact.topic.unreadCount">
          <span class="px-2 badge"> {{ contact.topic.unreadCount }}</span>
        </div>
        <div class="contact-detail">
          {{ contact.topic.detail }}
        </div>
      </div>
    </router-link>
  </ul>
</template>

<script>
export default {
  props: ["contacts"]
};
</script>

<style scoped>
.media-body {
  overflow: hidden;
}
.contact-author {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: -0.1px;
  color: #616161;
  margin-top: 8px;
}
.contact-detail {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -0.1px;
  color: #616161;
  margin-top: 6px;
  max-height: 18px;
  max-width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.contact-List .list {
  border-bottom: solid 1px #f5f5f5;
  cursor: pointer;
  padding: 15px;
}
.contact-List .media.active {
  background-color: rgba(216, 216, 216, 0.2);
}
.contact-List .media.new {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ContactNavigation.vue